import { useTranslation } from 'react-i18next';

import { Option } from '@/components/Form/SelectField';
import { DirectionRadioGroupOption } from '@/features/customsPass/createNewRequest/DirectionRadioGroupsOptions';
import { CROSSING_DIRECTION_COUNTRY, COUNTRIES_NAME } from '@/features/shared/constants';

export const useDirectionRadioGroupsOptions = () => {
  const { t } = useTranslation('customsPass_servicesOffer');

  const directionRadioGroupsOptions: Option[] = [
    {
      direction: CROSSING_DIRECTION_COUNTRY.EUUK,
      departure: COUNTRIES_NAME.EU,
      arrival: COUNTRIES_NAME.GB,
    },
    {
      direction: CROSSING_DIRECTION_COUNTRY.UKEU,
      departure: COUNTRIES_NAME.GB,
      arrival: COUNTRIES_NAME.EU,
    },
  ].map((item) => ({
    optValue: item.direction,
    optLabel: DirectionRadioGroupOption({
      directionLabel: `${item.departure} ${t('customsPass.servicesOffer.modal.crossing.direction.to')} ${item.arrival}`,
    }),
  }));

  return { directionRadioGroupsOptions };
};
